import { AnalyzeError } from "#modules/quoteRequestLines/AnalyzeError";

type Props = {
  errorText: string;
  retryText: string;
  onRetryAnalysis: () => void;
  secondaryRetryText: string;
  openDetailsPanel: () => void;
};

export const AnalysisErrorState = ({
  errorText,
  retryText,
  secondaryRetryText,
  onRetryAnalysis,
  openDetailsPanel,
}: Props) => {
  return (
    <AnalyzeError
      retryText={retryText}
      errorText={errorText}
      retryAction={onRetryAnalysis}
      secondaryRetryText={secondaryRetryText}
      secondaryRetryAction={openDetailsPanel}
    />
  );
};
